import { render, staticRenderFns } from "./AboutPromote.vue?vue&type=template&id=318fb8c5&"
import script from "./AboutPromote.vue?vue&type=script&lang=js&"
export * from "./AboutPromote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports